import { useT } from '../../i18n';
import { cn } from '../../lib/cn';

export const Skeleton = ({ className }: { className?: string }) => (
  <div className={cn('animate-pulse rounded-md bg-sunken', className)} aria-hidden="true" />
);

/** Placeholder for a list or table while its first page is loading. */
export const SkeletonRows = ({ rows = 5, className }: { rows?: number; className?: string }) => {
  const { t } = useT();

  return (
    <div
      className={cn('flex flex-col gap-2 p-4', className)}
      role="status"
      aria-label={t('common.loading')}
    >
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} className="h-10 w-full" />
      ))}
    </div>
  );
};
